<template>
    <div class="wrap-add-withdraw">
        <div class="wrap-content">
            <div class="title-page">Add Withdrawal</div>
            <div class="content">
                <div v-if="isFormNotNull">
                    <div class="content-depositor mb-3">
                        <div>
                            <span>Owner</span>
                            <span>{{ form.owner }}</span>
                        </div>
                        <div>
                            <span>Withdrawal Date</span>
                            <span>{{ form.withdrawal_date | formatDate }}</span>
                        </div>
                        <div>
                            <span>Permission IBOSS</span>
                            <span>{{ form.id_ijin }}</span>
                        </div>
                        <div>
                            <span>Permission Seri</span>
                            <span>{{ form.seri }}</span>
                        </div>
                        <div>
                            <span>Description</span>
                            <span>{{ form.description }}</span>
                        </div>
                    </div>

                    <table>
                        <thead>
                            <tr id="top">
                                <th scope="col" style="width: 70px"></th>
                                <th scope="col">Serial Number</th>
                                <th scope="col">Year</th>
                                <th scope="col" style="width: 200px">owner</th>
                                <th scope="col" style="width: 120px">Deposit Date</th>
                                <th scope="col">Fineness</th>
                                <th scope="col">Hallmark</th>
                                <th scope="col">Weight (gr)</th>
                            </tr>
                        </thead>
                        <tbody v-if="getIsLoading">
                            <tr>
                                <td colspan="10">
                                    <b-spinner></b-spinner>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(data, i) in metalData" :key="i" v-show="metalData.length != 0">
                                <td data-label="No">
                                    <input
                                        type="checkbox"
                                        name=""
                                        id=""
                                        v-model="withdrawalMetal"
                                        :value="data.metal_id"
                                        @input="addMetalWithdraw(data.metal_id, $event)"
                                    />
                                </td>
                                <td data-label="Serial Number">{{ data.serial_number }}</td>
                                <td data-label="Year">{{ data.year }}</td>
                                <td data-label="Owner">{{ data.owner }}</td>
                                <td data-label="Withdrawal Date">{{ data.metal_date | formatDate }}</td>
                                <td data-label="Fineness">{{ data.fineness }}</td>
                                <td data-label="Hallmark">{{ data.hallmark }}</td>
                                <td data-label="Weight">{{ data.weight }}</td>
                            </tr>
                            <tr v-show="metalData.length == 0">
                                <td colspan="10">No Data Available in Table</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="d-flex justify-content-end mt-3">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalData"
                            :per-page="perPage"
                            @change="handlePageChange"
                            aria-controls="new-table"
                            first-number
                            last-number
                            v-show="totalData > 10"
                        ></b-pagination>
                    </div>
                    <div class="mt-3 text-right">
                        <b-button variant="success" @click="submitMetal">
                            <b-spinner v-if="isLoading" small></b-spinner>
                            <span v-else>Submit</span>
                        </b-button>
                    </div>
                </div>
                <div class="text-center" v-else>
                    <h4>No data Available</h4>
                    <button type="button" class="btn btn-primer" @click="showModal">Add Withdrawal</button>
                </div>
                <b-modal ref="add-withdraw" hide-footer title="Add Withdraw">
                    <div class="d-block">
                        <form action="">
                            <div class="form-group">
                                <label>Depositor</label>
                                <select class="form-input" v-model="form.owner">
                                    <option value="ALL">ALL</option>
                                    <option value="LP000009">LP000009</option>
                                    <option value="CP000002">CP000002</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Withdrawal Date</label>
                                <input type="date" v-model="form.withdrawal_date" placeholder="Withdraw date" :max="today" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Permission IBOSS</label>
                                <select class="form-input" v-model="form.id_ijin">
                                    <option value="" selected disabled>Choose Permission IBOSS</option>
                                    <option v-for="(permission, i) in dataPermission" :key="i" :value="permission.id_ijin" v-show="permission.idlayan == '009004'">
                                        {{ permission.urailayan }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Permission Seri</label>
                                <select class="form-input" v-model="form.seri">
                                    <option value="" selected disabled>Choose Seri</option>
                                    <option v-for="(commodity, i) in commodityData" :key="i" :value="commodity.seri">
                                        {{ commodity.seri }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="">Description</label>
                                <input type="text" v-model="form.description" class="form-input" />
                            </div>
                        </form>
                    </div>
                    <div class="text-right">
                        <b-button class="mt-3" variant="primary" @click="addOwner"> Add Metal </b-button>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            withdrawalMetal: [],
            dataPermission: [],
            commodityData: [],
            metal_info: [],
            dataContract: [],
            isLoading: false,
            isFormNotNull: false,
            today: "",
            detailVolum: "",
            idMetal: "",
            form: {
                info: "",
                owner: "",
                id_ijin: "",
                seri: 0,
                withdrawal_date: "",
                metal_info: [],
                description: "",
            },
            currentPage: 1,
            perPage: 10,
            typePage: "deposit",
            type: "onexchange",
            contract_id: "",
            owner: "",
            hallmark: "",
            activity: "deposit",
            startDate: "",
            endDate: "",
            serialNumber: "",
            status: "005",
            dateType: "",
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];

        axios.get("/v2/attributes/contract").then((res) => {
            this.dataContract = res.data.data.body;
        });
        let dataOwner = JSON.parse(sessionStorage.getItem("owner"));
        if (dataOwner) {
            this.form.id_ijin = dataOwner.id_ijin;
            this.form.seri = dataOwner.seri;
            this.form.withdrawal_date = dataOwner.withdrawal_date;
            this.form.owner = dataOwner.owner;
            this.form.description = dataOwner.description;
        }

        axios.get("/v2/clearing/admin/abx/get/list_ijin").then((res) => {
            this.dataPermission = res.data.data.body;
        });
    },
    watch: {
        "form.id_ijin"() {
            if (this.form.id_ijin != "") {
                this.ibossID(this.form.id_ijin);
            }
        },
    },
    computed: {
        volume_gold() {
            let data = Math.round(this.no_seri.remaining_volume).toFixed(2);
            return data;
        },
        metalData() {
            return this.$store.state.vaultModul.depositData;
        },

        totalData() {
            return this.$store.state.vaultModul.totalData;
        },
        getIsLoading() {
            return this.$store.state.vaultModul.isLoading;
        },
    },
    beforeDestroy() {
        sessionStorage.removeItem("owner");
    },
    methods: {
        getData(activity, owner, startDate, endDate, serialNumber, hallmark, status, dateType, perPage, currentPage, contract_id, type) {
            this.$store.dispatch("getListMetal", {
                activity: activity,
                perPage: perPage,
                currentPage: currentPage,
                startDate: startDate,
                endDate: endDate,
                type: type,
                owner: owner,
                serialNumber: serialNumber,
                hallmark: hallmark,
                dateType: dateType,
                status: status,
                contract_id: contract_id,
            });
        },
        addMetalWithdraw(metal_id, event) {
            if (event.target.checked) {
                this.withdrawalMetal.push(metal_id);
            } else {
                this.withdrawalMetal.splice(this.withdrawalMetal.indexOf(metal_id), 1);
            }
        },
        handlePageChange(event) {
            this.currentPage = event;
            this.getData(
                this.activity,
                this.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.type
            );
        },
        openModal(metal, idMetal) {
            this.idMetal = idMetal;
            this.$refs["edit-metal"].show();
            let dimension = metal.dimension.split("x");
            this.lenghtDim = dimension[0];
            this.widthDim = dimension[1];
            this.hightDim = dimension[2];
        },
        editMetal() {
            this.$refs["edit-metal"].hide();
            location.reload();
        },
        ibossID(event) {
            axios.get("/v2/clearing/admin/abx/get/detail_ijin/" + event).then((res) => {
                this.commodityData = res.data.data.komoditas;
            });
        },
        showModal() {
            this.$refs["add-withdraw"].show();
            this.form = {
                contract_id: "",
                allocated: "",
                hub: "Jakarta",
                dimension: "",
                fineness: "",
                hallmark: "",
                weight: "",
                serial_number: "",
                year: "",
                item_description: "",
                metal_form: "",
            };
        },
        addOwner() {
            sessionStorage.setItem("owner", JSON.stringify(this.form));
            this.getData(
                this.activity,
                this.form.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.type
            );
            this.$refs["add-withdraw"].hide();
            this.isFormNotNull = true;
        },

        submitMetal() {
            this.form.metal_info = this.withdrawalMetal;
            this.isLoading = true;
            this.$store.dispatch("getLocation").then((resGeo) => {
                if (resGeo.cityData[0]) {
                    this.form.info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    this.form.info = JSON.stringify(data);
                }
                axios
                    .post("/v2/clearing/admin/abx/withdrawal", this.form)
                    .then((res) => {
                        if (!res.data.iserror) {
                            this.$toast.success("Add Withdrawal Success");
                            sessionStorage.removeItem("owner");
                            this.isLoading = false;
                            setTimeout(() => {
                                location.reload();
                            }, 2000);
                        }
                    })
                    .catch((error) => {
                        let msg;
                        if (error.response.data.data.err_message) {
                            msg = error.response.data.data.err_message;
                        } else {
                            msg = error.response.data.message;
                        }
                        this.isLoading = false;
                        this.$toast.error(msg);
                    });
            });
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.form-group {
    font-size: 15px;
}

.form-group label {
    width: 30%;
}

.form-input {
    width: 70%;
    padding: 0.16rem 0.5rem;
    border-radius: 5px;
    border: 0.5px solid;
    font-size: 14px;
}

.dimension {
    width: 21%;
    margin-right: 1rem;
}

.dimension:last-child {
    margin: unset;
}

.content-depositor div {
    display: flex;
    gap: 1rem;
}

.content-depositor div span:first-child {
    width: 8rem;
}
.content-depositor div span:last-child {
    font-weight: bold;
}

.form-group small {
    margin-left: 30%;
}
</style>
